import React, { useEffect, useState } from "react";
import { getBeratungPage } from "../lib/api";
import { Page, PageHeader, Section, SectionHead, IntroSplit, CardGrid, IconCard } from "../components/ui";

export default function BeratungInformationenPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getBeratungPage()
      .then((res) => !cancelled && setData(res))
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const {
    heroTitle,
    heroSubtitle,
    introKicker,
    introTitle,
    introText,
    heroImage,
    sectionTitle,
    sectionSubtitle,
    cards,
  } = data || {};

  return (
    <Page loading={!data} error={error}>
      <PageHeader
        parent={{ label: "Eltern & Schule", to: "/mitgestalten" }}
        current="Beratung & Informationen"
        title={heroTitle}
        subtitle={heroSubtitle}
      />

      <Section intro>
        <IntroSplit image={heroImage} kicker={introKicker} title={introTitle} text={introText} />
      </Section>

      <Section>
        <SectionHead title={sectionTitle} subtitle={sectionSubtitle} />
        
        <CardGrid cols={3}>
          {(cards || []).map((card, i) => (
            <IconCard
              key={card.id ?? i}
              iconName={card.iconName}
              title={card.title}
              text={card.text}
              email={card.email}
              website={card.website}
              headingLevel={2}
            />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}